// src/apiBase.js
// Single source of truth for where the backend lives.
//
// Local development:  no env var needed — falls back to localhost:5050.
// Production build:   set REACT_APP_API_URL (e.g. https://api.stalwart-electric.com
//                     or your Render backend URL) before `npm run build`.
//                     Create React App bakes it in at build time.
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5050';
